import React from 'react';
import BaseContainer from './BaseContainer.tsx';
import DailyGameHeader from '../GameHeader/GameHeader.tsx';
import { GameType } from '../../types/GameType.ts';

interface DailyGameContainerProps {
  children: React.ReactNode;
  gameType: GameType;
  gameNumber: number;
  isArchive: boolean;
  onHowToPlayClick: () => void;
  onYesterdayClick: () => void;
  onUserStatsClick: () => void;
}

export default function DailyGameContainer(props: DailyGameContainerProps) {
  const {
    children,
    gameType,
    gameNumber,
    isArchive,
    onHowToPlayClick,
    onYesterdayClick,
    onUserStatsClick,
  } = props;

  const header = (
    <DailyGameHeader
      gameType={gameType}
      gameNumber={gameNumber}
      isArchive={isArchive}
      onClickHowToPlay={onHowToPlayClick}
      onClickYesterday={onYesterdayClick}
      onClickUserStats={onUserStatsClick}
    />
  );

  return (
    <BaseContainer header={header}>
      {children}
    </BaseContainer>
  );
}
